import React from 'react';
import { Img } from 'react-image';
import { monthDayTime } from '../utils/date';


interface ProfileWithNameProps {
  profileImg?: string;
  nickname: string;
  /** 주면 닉네임 아래에 작게 적는다. 안 주면 아무것도 그리지 않는다 */
  date?: string;
  /** 초까지 보여준다. 점령전 기록처럼 같은 분에 여러 건이 몰릴 때 필요하다 */
  showSeconds?: boolean;
  size?: number; // 이미지 크기
  color?: string; // 닉네임 색상
  fontSize?: number;
  borderRadius?: string | number; // 이미지 border radius
  style?: React.CSSProperties;
  reverse?: boolean; // true면 이름이 왼쪽, 프로필이 오른쪽
  defaultImg?: string; // 기본 이미지 경로
  alignRight?: boolean; // true면 텍스트를 오른쪽 정렬
}

// 형식은 utils/date 에 모아 두었다. 연도는 뺀다 — 같은 시즌 안의 기록을 견주는
// 값이라 자리만 먹는다

const ProfileWithName: React.FC<ProfileWithNameProps> = ({
  profileImg,
  nickname,
  date,
  showSeconds = false,
  size = 16,
  color = '#1976d2',
  fontSize = 15,
  borderRadius = '50%',
  style = {},
  reverse = false,
  defaultImg = '/images/default-profile.png',
  alignRight = false,
}) => {
  // 프로필 이미지는 서버에서 타임스탬프를 포함한 URL을 반환하므로 그대로 사용
  const getProfileImg = (img?: string) => {
    if (!img) return defaultImg;
    return img;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexDirection: reverse ? 'row-reverse' : 'row', ...style }}>
      <Img
        src={getProfileImg(profileImg)}
        unloader={<img loading="lazy" src={defaultImg} alt="프로필" style={{ width: size, height: size, borderRadius, objectFit: 'cover', background: '#e3f0ff', border: '2px solid #e3f0ff', verticalAlign: 'middle', display: 'inline-block' }} />}
        alt="프로필"
        style={{ width: size, height: size, borderRadius, objectFit: 'cover', background: '#e3f0ff', border: '2px solid #e3f0ff', verticalAlign: 'middle', display: 'inline-block' }}
      />
      {/* 닉네임과 시각을 한 칸에 세로로 쌓는다. 시각은 안 주면 그리지 않으므로
          예전처럼 닉네임만 쓰던 자리는 그대로다 */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          alignItems: alignRight ? 'flex-end' : 'flex-start',
        }}
      >
        <span style={{ color, fontWeight: 700, fontSize, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%', textAlign: alignRight ? 'right' : 'left' }}>{nickname}</span>
        {date && (
          <span
            style={{
              color: '#999',
              fontWeight: 400,
              fontSize: Math.max(10, fontSize - 4),
              whiteSpace: 'nowrap',
              lineHeight: 1.3,
              textAlign: alignRight ? 'right' : 'left',
            }}
          >
            {monthDayTime(date, showSeconds)}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProfileWithName; 